export function setupState () {
	/* #### Simple State Machine #### */
	window.scanner = {}
	const scanner = window.scanner

	/* ## ReRender ## */
	scanner.renderCount = 0
	scanner.rerender = () => { scanner._rerender() }

	/* ## Connection ## */
	scanner.connected = false
	scanner.connect = () => { scanner._connection(true) }
	scanner.disconnect = () => { scanner._connection(false) }

	/* ## Registration ## */
	scanner.id = ''
	scanner.registered = false

	/* ## Loading ## */
	scanner.loader = {}
	scanner.loader.display = false
	scanner.loader.open = () => { scanner.loader._display(true) }
	scanner.loader.close = () => { scanner.loader._display(false) }

	/* ## Messages ## */
	scanner.message = {}
	scanner.message.renderCount = 0
	scanner.message.display = false
	scanner.message.title = ''
	scanner.message.content = ''
	scanner.message.closeable = false
	scanner.message.send = (
		title = 'Message',
		content = 'A message from mothership.',
		closeable = false
	) => {
		scanner.message.title = title
		scanner.message.content = content
		scanner.message.closeable = closeable
		if (scanner.message.display) {
			scanner.message.update()
			window.debug(`📝Message: Already Open, Hot Reloading New Content.`)
		} else {
			scanner.message.open()
			window.debug(`📝Message: Sending New Message.`)
		}
		window.debug({ "title": title, "content": content })
	}
	scanner.message.clear = () => {
		scanner.message.title = ''
		scanner.message.content = ''
		scanner.message.closeable = false
		scanner.message.update()
		scanner.message.close()
	}
	scanner.message.update = () => { if (scanner.message.display) { scanner.message._update() } }
	scanner.message.rerender = () => { if (scanner.message.display) { scanner.message._rerender() } }
	scanner.message.open = () => { scanner.message._display(true) }
	scanner.message.close = () => { scanner.message._display(false) }

}
